<template>
    <div class="container">
        <card class="pd12">
            <div class="title">{{info.awardTitle || '奖励名称'}}</div>
            <div class="txt">获奖时间：{{info.time.substring(0,10) }}</div>
            <div class="desc-tit">备注信息</div>
            <div class="desc">{{info.awardDetail}}</div>
        </card>
    </div>
</template>
<script>
    import card from '../travelAgency/components/card';
    export default {
        components: {
            card
        },

        data () {
            return {
                info: {}
            };
        },

        computed: {},

        watch: {},

        methods: {},

        mounted () {},
        created () {
            let info = JSON.parse(this.$route.query.info);
            this.info.awardTitle = info.awardTitle || '';
            this.info.time = info.time || '';
            this.info.awardDetail = info.awardDetail || '暂无信息';
        }
    };
</script>
<style scoped lang="less">
.container {
    height: 100vh;
    background-color: @base-bgcolor;
    padding: 16px 12px;
    box-sizing: border-box;
    .pd12 {
        .title {
            font-size: 20px;
            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
        }

        .txt {
            margin-top: 12px;
            margin-bottom: 16px;
            font-size: 14px;

            font-weight: 400;
            color: rgba(153, 153, 153, 1);
        }

        .desc-tit {
            font-size: 14px;

            font-weight: 400;
            color: rgba(153, 153, 153, 1);
        }

        .desc {
            margin-top: 4px;
            font-size: 14px;

            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
        }
    }
}
</style>
